// Curata descrierea produsului: elimina linkurile externe, elementele de lista goale,
// si uneste paragrafele scurte de tip "eticheta" (bifa + titlu ingrosat, terminat in ":")
// cu paragraful de text care le urmeaza, acolo unde feed-ul le-a despartit gresit.
document.addEventListener('DOMContentLoaded', function () {
  var desc = document.querySelector('.product__description');
  if (!desc) return;

  // 1) Elimina linkurile externe, pastrand textul din interior
  desc.querySelectorAll('a').forEach(function (link) {
    var span = document.createElement('span');
    span.innerHTML = link.innerHTML;
    link.replaceWith(span);
  });

  // 2) Elimina elementele <li> goale si listele ramase goale
  desc.querySelectorAll('li').forEach(function (li) {
    if (!li.textContent.trim()) li.remove();
  });
  desc.querySelectorAll('ul, ol').forEach(function (list) {
    if (!list.querySelector('li')) list.remove();
  });

  // 3) Uneste paragrafele scurte de tip "eticheta" cu paragraful urmator
  desc.querySelectorAll('p').forEach(function (p) {
    var next = p.nextElementSibling;
    if (!next || next.tagName !== 'P') return;
    var strongCount = p.querySelectorAll('strong').length;
    var text = p.textContent.trim();
    var endsWithColon = /:\s*$/.test(text);
    if (strongCount === 1 && endsWithColon && text.length > 0 && text.length < 80) {
      next.insertBefore(document.createTextNode(' '), next.firstChild);
      while (p.lastChild) {
        next.insertBefore(p.lastChild, next.firstChild);
      }
      p.remove();
    }
  });
});